import React, { useState, useEffect } from "react";
import { useToggle, useGeolocation } from "react-use";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { CircularProgress, Grid,ButtonGroup } from "@material-ui/core";
import _ from "lodash";
import { Typography, RoundedButton } from "@packages/ui";
import * as appActions from "../../actions/appActions";
import UploadBlockedDialog from "./UploadBlockedDialog";
import { useCurrentRental, useLoggedInRental } from "../../hooks/rentalHooks";

const UploadRentalPhotoPrompt = () => {
  const currentRental = useCurrentRental();
  const currentRA = currentRental.rental_agreement_number;
  const loggedInRental = useLoggedInRental();
  const { error: locationError } = useGeolocation({ enableHighAccuracy: true });
  const [blockUpload, toggleBlock] = useToggle(false);
  const [blockReason, setBlockReason] = useState("");

  useEffect(() => {
    if (currentRA !== loggedInRental) {
      setBlockReason("incorrect-ra");
      return toggleBlock(true);
    }
/* for testing */
    // if (locationError) {
    //   setBlockReason("blocked-location-service");
    //   return toggleBlock(true);
    // }

    return toggleBlock(false);
  }, [loggedInRental, currentRA]);

  const [showModal, toggleShowModal] = useToggle(false);
  const showAlert = () => toggleShowModal(true);
  const hideAlert = () => toggleShowModal(false);

  const auth = useSelector((state) => ({ ...state.auth }));
  const app = useSelector((state) => ({ ...state.app }));
  const loading = _.get(app, "loading", false);
  const dispatch = useDispatch();
  const handleRefreshPhoto = () => {
    dispatch(appActions.refreshPhotos(auth));
  };

  return (
    <>
      <Typography paragraph>
        If you find any difference between your vehicle&apos;s condition and these photos or the
        rental agreement, please speak with one of our team members OR we invite you to take your
        own set of photos <strong>within 60 minutes of commencing your rental</strong>. <br/><br/>Click on <strong>&quot;New Photos&quot;</strong> and follow the
        prompts to upload your own set of photos. 
      </Typography>
      <Grid container>
       <ButtonGroup orientation="horizontal" fullWidth={true}>
        <Grid item sm={3} xs={6} lg={2} xl={3}>
        
          {!blockUpload && (
            
            <RoundedButton
              title="New Photos"
              component={Link}
              to="/app/upload-vehicle-photos"
              fullWidth={true}
            />
          
          )}
          {blockUpload && (
            <>
              <RoundedButton
                title="New Photos"
                onClick={showAlert}
                fullWidth={true}
              />
              <UploadBlockedDialog
                showModal={showModal}
                onCloseAction={hideAlert}
                blockReason={blockReason}
                correctRA={currentRA}
              />
            </>
          )}
        </Grid>
        <Grid item sm={2} xs={6}>
          <RoundedButton
            onClick={handleRefreshPhoto}
            disabled={loading}
            fullWidth={true}
            style={{marginLeft:'5px'}}
          >
            Refresh
            {loading && <CircularProgress />}
          </RoundedButton>
        </Grid>
        </ButtonGroup>
      </Grid>
    </>
  );
};

export default UploadRentalPhotoPrompt;
